import { dateSeparator } from '../types/date-separator.type';

export const isValidDate = (date: string, separator: dateSeparator = '/', yearFirst = false): boolean => {
  const dateMinLength = 10;
  let parsedDate: number;

  if (!yearFirst) {
    const values = date.split(separator);

    const day = values[0];
    const month = values[1];
    const year = values[2];

    const formattedDate = `${year}${separator}${month}${separator}${day}`;

    if (formattedDate.length < dateMinLength) {
      return false;
    }

    parsedDate = Date.parse(formattedDate);
  } else {
    if (date.length < dateMinLength) {
      return false;
    }

    parsedDate = Date.parse(date);
  }

  return !isNaN(parsedDate);
};
